module.exports = __webpack_public_path__ + "img/hypertap.a875234b.png";